import * as React from 'react'

function SvgOneToOneXIDR(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_901_144734)">
        <ellipse
          opacity="0.2"
          cx="11"
          cy="18.1953"
          rx="9"
          ry="9"
          fill="#00D37E"
        />
        <path
          d="M11.0703 18.0007H9.76527V13.5277L8.28027 14.4187V13.0777L9.93627 12.1147H11.0703V18.0007Z"
          fill="#00D37E"
        />
        <g filter="url(#filter0_d_901_144734)">
          <ellipse cx="25" cy="18" rx="9" ry="9" fill="white" />
        </g>
        <path
          d="M20.0073 23.65H19L20.1535 21.7979L19.0542 20H20.0235L20.63 21.0668L21.2095 20H22.2276L21.1228 21.8033L22.298 23.65H21.307L20.6463 22.5128L20.0073 23.65Z"
          fill="#00D37E"
        />
        <path d="M23.6848 23.65H22.8508V20H23.6848V23.65Z" fill="#00D37E" />
        <path
          d="M25.687 23.65H24.4414V20H25.6978C26.2466 20 26.696 20.1697 27.0462 20.5091C27.3964 20.8448 27.5715 21.2636 27.5715 21.7654C27.5715 22.3503 27.3982 22.8106 27.0516 23.1464C26.7087 23.4821 26.2538 23.65 25.687 23.65ZM25.6707 20.6878H25.297V22.9677H25.6761C26.0119 22.9677 26.27 22.863 26.4505 22.6536C26.6347 22.4442 26.7267 22.1481 26.7267 21.7654C26.7267 21.4405 26.6347 21.1806 26.4505 20.9856C26.2664 20.787 26.0065 20.6878 25.6707 20.6878Z"
          fill="#00D37E"
        />
        <path
          d="M29.3836 20.6769H28.972V21.7059H29.3674C29.7284 21.7059 29.9089 21.529 29.9089 21.1751C29.9089 21.0199 29.862 20.899 29.7681 20.8123C29.6742 20.7221 29.5461 20.6769 29.3836 20.6769ZM28.972 23.65H28.1381V20H29.3999C29.8078 20 30.1346 20.1083 30.3801 20.3249C30.6292 20.5415 30.7537 20.8231 30.7537 21.1697C30.7537 21.6896 30.5317 22.0488 30.0876 22.2474L31.0137 23.65H30.0172L29.2266 22.3828H28.972V23.65Z"
          fill="#00D37E"
        />
        <path
          d="M26.3701 18.0007H25.0651V13.5277L23.5801 14.4187V13.0777L25.2361 12.1147H26.3701V18.0007Z"
          fill="#00D37E"
        />
        <path d="M7.83398 23.65H7V20H7.83398V23.65Z" fill="#00D37E" />
        <path
          d="M9.83612 23.65H8.59057V20H9.84695C10.3957 20 10.8452 20.1697 11.1954 20.5091C11.5456 20.8448 11.7207 21.2636 11.7207 21.7654C11.7207 22.3503 11.5474 22.8106 11.2008 23.1464C10.8578 23.4821 10.4029 23.65 9.83612 23.65ZM9.81987 20.6878H9.44621V22.9677H9.82529C10.161 22.9677 10.4192 22.863 10.5997 22.6536C10.7838 22.4442 10.8759 22.1481 10.8759 21.7654C10.8759 21.4405 10.7838 21.1806 10.5997 20.9856C10.4156 20.787 10.1556 20.6878 9.81987 20.6878Z"
          fill="#00D37E"
        />
        <path
          d="M13.5328 20.6769H13.1212V21.7059H13.5165C13.8776 21.7059 14.0581 21.529 14.0581 21.1751C14.0581 21.0199 14.0111 20.899 13.9173 20.8123C13.8234 20.7221 13.6952 20.6769 13.5328 20.6769ZM13.1212 23.65H12.2872V20H13.549C13.957 20 14.2837 20.1083 14.5292 20.3249C14.7783 20.5415 14.9029 20.8231 14.9029 21.1697C14.9029 21.6896 14.6809 22.0488 14.2368 22.2474L15.1628 23.65H14.1664L13.3757 22.3828H13.1212V23.65Z"
          fill="#00D37E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_901_144734"
          x="6"
          y="3"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.662745 0 0 0 0 0.396078 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_901_144734"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_901_144734"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_901_144734">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgOneToOneXIDR
